import Vue from 'vue';
import { Component, Emit } from 'vue-property-decorator';
import {
  TICKET_MODULE_NAMESPACE,
  TICKET_GET_TICKET_ACTIONS,
  TICKET_ACTION_SEND_MESSAGE,
  TICKET_ACTION_SEND_FILE,
  TICKET_ACTION,
  TICKET_GET_TICKET,
  TICKET_RECORD_ASK_APPARTMENT,
  TICKET_REQUEST_TO_JOIN,
  TICKET_GET_CLOSURE_REASON,
  TICKET_GET_REASONS,
  TICKET_REQUEST_TO_JOIN_CHANNEL,
  TICKET_REMOVE_PARTICIPANTS,
  TICKET_RESET_CURRENT_CHANNEL,
  TICKET_INTERVENTION_REPORT,
  TICKET_UPDATE_CURRENT_CHANNEL_ACTIONS,
  TICKET_SET_LOADER_STATE
} from '../../../store/ticket';
import { namespace } from 'vuex-class';
import { ITicketListingViewModel, ITicketChannel, ITicketInterventionReport, TicketInterventionReport } from '../../../models/ticket';
import { USER_MODULE_NAMESPACE } from '../../../store/user/user-types.store';
import { IUserDetails, UserCompactInfo } from '../../../models/user';
import TicketChatEditor from '../components/ticket-chat-editor';
import { SEARCH_MODULE_NAMESPACE, SEARCH_REQUEST_BYKEYS } from '../../../store/search';
import { SearchEntities } from '../../../common/enums/search-entities.enum';
import { ActivityStatus, StateTypes } from '../../../common/enums';
import { AGENDA_RECORD, AGENDA_MODULE_NAMESPACE } from '../../../store/agenda/agenda-types.store';
import {
  NOTIFICATION_MODULE_NAMESPACE,
  NOTIFICATION_MARKAS_READ,
  NOTIFICATION_CURRENT_CHANNEL,
} from '../../../store/notification';

import * as moment from "moment";
import * as _ from "lodash";
import { DateTimeHelper } from '../../../utils/DateTimeHelper.util';
import { IAppointment } from '../../../models/appointment';
import {
  DOCUMENT_MODULE_NAMESPACE,
  DOCUMENT_SEND_TICKET_DOCUMENT,
  DOCUMENT_SET_DOCUMENT_PARAMETER
} from "../../../store/document";
import { IDocumentParamter } from "../../../models/documents";
import { eventBus } from '../../../main';

const TicketStore = namespace(TICKET_MODULE_NAMESPACE);
const UserStore = namespace(USER_MODULE_NAMESPACE);
const SearchStore = namespace(SEARCH_MODULE_NAMESPACE);
const AgendaStore = namespace(AGENDA_MODULE_NAMESPACE);
const NotificationStore = namespace(NOTIFICATION_MODULE_NAMESPACE)
const DocumentStore = namespace(DOCUMENT_MODULE_NAMESPACE)

@Component({
  components: {
    'chat-header': async () => import('../components/ticket-chat-header/TicketChatHeader.vue'),
    'chat-content': async () => import('../components/ticket-chat-message/TicketChatMessage.vue'),
    'chat-editor': async () => import('../components/ticket-chat-editor/TicketChatEditor.vue'),
    'chat-agenda-modal': async () => import('../../agenda/components/agenda-modal-vertical/AgendaModalVertical.vue'),
    'chat-attachment-modal': async () => import('../components/ticket-chat-modal-attach-documents/TicketChatModalAttachDocument.vue'),
    'chat-mandate-speaker-modal': async () => import('../components/ticket-chat-modal-mandate-speaker/TicketChatModalMandateSpeaker.vue'),
    'chat-intervention-report-modal': async () => import('../components/ticket-modal-generate-intervention-report/TicketModalGenerateInterventionReport.vue'),
    'chat-agenda': async () => import('../components/ticket-calendar/TicketCalendar.vue'),
    'document-modal-vertical': async () => import('../../documents/components/document-modal-vertical/DocumentModalVertical.vue'),
  }
})
class TicketChatChildContainer extends Vue {
  private _clearTimeout: any;
  private _messageListener: any;
  /**
   *
   */
  get lblSetting() {
    return {
      ...require('../../../locales/ticket').default,
      ...require('../../../locales/button').default,
      ...require('../../../locales/validation-messages').default
    }
  }
  dtTicketInterventionReport: ITicketInterventionReport;
  dtCanRender: boolean;
  dtError: any;
  dtErrorModalVisible: boolean;
  dtDetailError: any;
  dtDetailErrorModalVisible: boolean;
  dtConfirmModalVisible: boolean;
  dtConfirm: any;
  dtClosureReason: any;
  dtTicketReason: any;
  dtClosureReasonRules: any;
  dtClosureReasonDescription: string;
  dtRequestModal: { visible: boolean, type: string | null, icon?: string, actionName?: string, translationKey?: string };
  dtIndependentContractors: any[];
  dtMessages: any[];
  dtTemporaryMessages: any[];
  dtAttachments: any[];
  dtMessage: { message: string, actorId: number }
  dtMandateRequestPayload: { attachments: any[], fk_actor_entity: number[], service_order: string };
  dtQuoteRequestPayload: { attachments: any[], fk_actor_entity: number[], quote_request_text: string };
  dtRules: {
    ticketActionRequestQuoteRule?: boolean | any[]
  }
  dtDate: { startDate: string, endDate?: string };
  dtRequestLoading: boolean;
  dtFileUploading: any;
  dtWithoutValidateIsLoading: boolean;
  dtSendInterventionReportLoading: boolean;


  dtUpdateAppointmentField: boolean

  constructor() {
    super();
    let mom: moment.Moment = DateTimeHelper.roundMinute();
    this.dtTicketInterventionReport = new TicketInterventionReport(
      mom.format('YYYY-MM-DDTHH:mm:00'),
      mom.add(30, "m").format('YYYY-MM-DDTHH:mm:00')
    )
    this.dtCanRender = false;
    this.dtError = null;
    this.dtErrorModalVisible = false;
    this.dtDetailError = null;
    this.dtDetailErrorModalVisible = false;
    this.dtConfirm = null;
    this.dtConfirmModalVisible = false;
    this.dtClosureReasonRules = null;
    this.dtRequestModal = { visible: false, type: null };
    this.dtIndependentContractors = [];
    this.dtClosureReasonDescription = null;
    this.dtAttachments = [];
    this.dtWithoutValidateIsLoading = false;
    this.dtRules = {}
    this.dtMessages = [];
    this.dtTemporaryMessages = [];
    this.dtMandateRequestPayload = this.initMandate('service_order');
    this.dtQuoteRequestPayload = this.initMandate('quote_request_text');
    this.dtRequestLoading = false;
    this.dtClosureReason = null;
    this.dtTicketReason = null;
    this.dtFileUploading = false;
    this.dtSendInterventionReportLoading = false
    this.dtUpdateAppointmentField = false
    const date = moment()
    this.dtDate = {
      startDate: date.format('YYYY-MM-DDTHH:mm:ss'),
      endDate: date.add(30, 'm').format('YYYY-MM-DDTHH:mm:ss')
    }
  }

  @UserStore.Getter userInfo: IUserDetails;
  @UserStore.Getter isManager: boolean;
  @SearchStore.Getter contractors: any[];
  @TicketStore.Getter attachmentsInQueue: any[];
  @TicketStore.Getter currentTicket: ITicketListingViewModel;
  @TicketStore.Getter currentChannel: ITicketChannel;
  @TicketStore.Getter message: any;
  @TicketStore.Getter actionLoading: ActivityStatus;
  @TicketStore.Getter ticketClosureReasons: { id: number, name: string, description: string }[];
  @TicketStore.Getter ticketReasons: { id: number, name: string, description: string }[];
  @TicketStore.Getter activityStatus: ActivityStatus;
  @AgendaStore.Getter appointment: IAppointment;

  @TicketStore.Action(TICKET_GET_TICKET_ACTIONS)
  storeGetChannel: (payload: { channelId: number, ticketId: number }) => Promise<any>;

  @TicketStore.Action(TICKET_REQUEST_TO_JOIN)
  storeRequestToJoin: (payload: { ticketId: string, channelId: string }) => Promise<any>;

  @TicketStore.Action(TICKET_REQUEST_TO_JOIN_CHANNEL)
  storeRequestToJoinChannel: (payload: { ticketId: string, channelId: string }) => Promise<any>;

  @TicketStore.Action(TICKET_GET_TICKET)
  storeGetTicket: (action: { ticketId: number, isTicketModule?: boolean }) => Promise<any>;

  @TicketStore.Action(TICKET_RECORD_ASK_APPARTMENT)
  storeAskAppointment: (payload: { ticketId: number, startDate: string }) => Promise<any>;

  @TicketStore.Action(TICKET_ACTION_SEND_MESSAGE)
  storeSendMessage: ({ ticketId, channelId, message, createdAt }) => Promise<any>;

  @TicketStore.Action(TICKET_ACTION_SEND_FILE)
  storeSendFile: ({ ticketId, channelId, data }) => Promise<boolean>;

  @TicketStore.Action(TICKET_ACTION)
  storeTicketActionRequest: (payload: { actionName: string, ticketId: string, data?: any }) => Promise<any>;

  @TicketStore.Action(TICKET_GET_CLOSURE_REASON)
  storeGetClosureReason: () => Promise<any>;

  @TicketStore.Action(TICKET_GET_REASONS)
  storeGetTicketReason: () => Promise<any>;

  @TicketStore.Action(TICKET_REMOVE_PARTICIPANTS)
  storeRemoveParticipant: (option: { ticketId: string, channelId: string, data: any[] }) => Promise<any>;

  @TicketStore.Action(TICKET_INTERVENTION_REPORT)
  storeRecordInterventionReport: (option: { ticketId: string, data: ITicketInterventionReport }) => Promise<any>;

  @SearchStore.Action(SEARCH_REQUEST_BYKEYS)
  storeGetIndependentContractors: (keys: string[]) => Promise<any[]>;

  @AgendaStore.Action(AGENDA_RECORD)
  storeRecordAppointment: (type?: string) => Promise<any>

  @NotificationStore.Action(NOTIFICATION_MARKAS_READ)
  storeMarkAsRead: (channelId: string) => Promise<any>;

  @DocumentStore.Action(DOCUMENT_SEND_TICKET_DOCUMENT)
  storeSendDocument: (payload: { ticketId: string, channelId: string }) => Promise<any>

  @NotificationStore.Mutation(NOTIFICATION_CURRENT_CHANNEL)
  storeClearCurrentChannel: (channelId: number) => void;

  @TicketStore.Mutation(TICKET_RESET_CURRENT_CHANNEL)
  storeResetCurrentChannel: () => void;

  @TicketStore.Mutation(TICKET_UPDATE_CURRENT_CHANNEL_ACTIONS)
  storeUpdateCurrentChannelActions: (data) => void;

  @TicketStore.Mutation(TICKET_SET_LOADER_STATE)
  storeSetTicketLoaderState: (payload?: { key: string, value: boolean }) => void

  @DocumentStore.Mutation(DOCUMENT_SET_DOCUMENT_PARAMETER)
  storeSetDocumentParameter: (payload: IDocumentParamter) => void

  get canAskAppointment(): boolean {
    return !this.$route.meta.add_appointment;
  }

  get isCreating(): boolean {
    return this.appointment.id === undefined;
  }
  get coCurrentChannelId(): number | null {
    return parseInt(this.$route.params.cid);
  }
  get coCurrentTicketId(): number | null {
    return parseInt(this.$route.params.id);
  }
  get coActions() {
    return this.currentChannel.actions;
  }
  set coActions(action) {
    this.storeUpdateCurrentChannelActions(action)
  }
  get coTicketMembers() {
    const keys: string[] = [/*'creator',*/ 'declarant', 'tenants', 'owners', 'caretakers', 'independents_contractors_mandate', 'managers_assigned', 'ticket_participants'];
    let ticketMembers = this.currentTicket.managers || [];
    keys.forEach(key => {
      const next = this.currentTicket[key];
      if (next)
        ticketMembers = ticketMembers.concat(next)
    })
    return ticketMembers.map(m => new UserCompactInfo(m)).filter((m, i, self) => {
      const inn = self.findIndex((me, inn) => {
        return me.id === m.id;
      })
      return i === inn;
    });
  }
  get coIsOwner(): boolean {
    if (this.coTicketMembers.length === 0 && this.userInfo.id === undefined) return false;
    return this.coParticipant.find(manager => manager.id === this.userInfo.id) !== undefined
      || this.coTicketMembers.find(x => x.id === this.userInfo.id) !== undefined;
  }
  get coCanJoinTicket(): boolean {
    return this.coIsOwner === false
      && this.$route.meta.join_ticket
      && this.currentChannel.type === "public";
  }
  get coChannelClosed(): boolean {
    return this.currentChannel.state === 'close'
  }
  get coCanJoinChannel(): boolean {
    return this.coIsOwner
      && this.$route.meta.join_channel
      && this.isNotBelongToChannel
      && this.currentChannel.type !== "public";
  }
  get isNotBelongToChannel(): boolean {
    return (this.currentChannel.participants || []).filter(x => x['fk_actor_entity'] === this.userInfo.id).length === 0
  }
  get coParticipant() {
    return (this.currentChannel.participants || []).map(participant => new UserCompactInfo(participant.entity));
  }

  get isCreateAppointment() {
    return this.dtRequestModal.type === TicketChatEditor.TICKET_EDITOR_ACTION_CREATEAPPOINTMENT;
  }
  get isAskAppointment() {
    return this.dtRequestModal.type === TicketChatEditor.TICKET_EDITOR_ACTION_ASKAPPOINTMENT;
  }
  get isAskQuote() {
    return this.dtRequestModal.type === TicketChatEditor.TICKET_EDITOR_ACTION_ASKQUOTE;
  }
  get isAttachFile() {
    return this.dtRequestModal.type === TicketChatEditor.TICKET_EDITOR_ACTION_ATTACHFILE;
  }
  get isAttachDocument() {
    return this.dtRequestModal.type === TicketChatEditor.TICKET_EDITOR_ACTION_ATTACHDOCUMENT;
  }
  get isAnnotation() {
    return this.dtRequestModal.type === TicketChatEditor.TICKET_EDITOR_ACTION_ANNOTATION;
  }
  get isMandateSpeaker() {
    return this.dtRequestModal.type === TicketChatEditor.TICKET_EDITOR_ACTION_MANDATEASPEAKER;
  }
  get isGenerateInterventionReport() {
    return this.dtRequestModal.type === TicketChatEditor.TICKET_EDITOR_ACTION_GENERATE_REPORT
  }
  get isClose() {
    return this.dtRequestModal.type === TicketChatEditor.TICKET_EDITOR_ACTION_CLOSE;
  }
  get maxWidth() {
    if (this.isClose) {
      return '40%';
    }
    else if (this.isGenerateInterventionReport) {
      return '50%'
    }
    else if (this.isAttachDocument) {
      return '90%';
    }
    else if (this.isMandateSpeaker || this.isAskQuote) {
      return '90%';
    }
    else if (this.isCreateAppointment)
      return '90%';


    return undefined;

  }
  get form() {
    return (this.$refs && this.$refs.modal)
  }

  get coContractorsSource(): any[] {
    return this.currentTicket.independents_contractors_mandate;
  }
  get coTicketName(): string {
    return this.currentTicket.subject
  }
  get coTicketDescription(): string {
    return this.currentTicket['description']
  }
  get coClosureReasons(): { id: number, name: string, description: string }[] {
    return this.ticketClosureReasons;
  }
  get coTicketsReasons(): { id: number, name: string, description: string }[] {
    return this.ticketReasons;
  }
  get coTicketBlock(): string {
    return this.currentTicket.block!;
  }

  initMandate(key: string): any {
    return {
      attachments: [],
      fk_actor_entity: [],
      [key]: ''
    };
  }

  coHasContractor(): boolean {
    return this.currentTicket.independents_contractors_mandate!.length > 0
  }
  configRules() {
    this.dtRules.ticketActionRequestQuoteRule = [(v) => v.length > 0 || this.$t(this.lblSetting.declarererRequired)]
  }

  handleOpenModal(params) {
    console.log('FFFFFFFFFFFFFFFFF', params)
    this.dtConfirm = params
    this.dtRequestModal.visible = true
    this.dtRequestModal.type = TicketChatEditor.TICKET_DELETE_MSG
    this.dtRequestModal.icon = null
    this.dtRequestModal.actionName = null
    this.dtRequestModal.translationKey = null
    this.dtConfirmModalVisible = params.open
  }

  HandleConfirmModal() {
    this.dtConfirm.func()
      .then(res => {
        this.handleCloseConfirm()
      })

  }

  handleCloseConfirm() {
    this.dtConfirmModalVisible = false
  }

  beforeDistroy()
  {

  }

  mounted() {
    setTimeout(() => {
      this.dtCanRender = true;
    }, 500);
    this._messageListener = undefined;

    this.configRules();
    this.storeGetIndependentContractors([SearchEntities.Contractor])
      .catch(error => console.log(error))
    this.dtClosureReasonRules = [(v) => !!v || this.$t(this.lblSetting.closureReasonValid)];
    this.getActions();
    this.dtMessages = this.dtMessages.filter(x => x.fkChannel === this.$route.params.id);
    this.storeGetClosureReason();
    this.storeGetTicketReason();
    this.storeMarkAsRead(this.$route.params.cid)

    this.$watch('coCurrentChannelId', (val, old) => {
      this.getActions();
      this.storeMarkAsRead(val)
    })
    this.$watch('activityStatus', (value) => {
      if (value !== ActivityStatus.Loading) {
        this._messageListener = this.$watch('message', this.handleMessageChange)
      } else if (this._messageListener) {
        this._messageListener()
      }
    })
  }

  handleMessageChange(newVal, oldVal) {
    /* console.log('NEW VAL MSG', newVal)
    console.log('OLD VAL MSG', oldVal) */
    if (newVal && newVal.fk_action_channel === this.coCurrentChannelId) {
      this.handleReceiveNewMessage(newVal);
    }
  }

  async handleSendTemporaryDocuments() {
    if (this.attachmentsInQueue.length && this.attachmentsInQueue.filter(x => !x.uploaded).length > 0) {
      setTimeout(() => this.attachmentsInQueue.forEach(doc => {
        if (!doc.uploaded) {
          this._handleSendfile(doc)
        }
      }), 500)
    }
  }

  getActions() {
    setTimeout(() => {
      if (!isNaN(this.coCurrentChannelId) && !isNaN(this.coCurrentTicketId)) {
        this.dtMessages = [];
        this.dtMessage = null;
        this.storeGetChannel({ channelId: this.coCurrentChannelId, ticketId: this.coCurrentTicketId })
          .then(() => {
            this.handleSendTemporaryDocuments();
          })
          .catch(error => {
            this.dtDetailError = error;
            this.dtDetailErrorModalVisible = true;
          })
      }
    }, 300);
  }

  get coIcon(): string {
    return this.dtRequestModal.type && this.dtRequestModal.icon;
  }

  /** Return true to close modal */
  handleBeforeClose() {
    this.dtClosureReason = null;
    this.dtTicketReason = null;
    this.dtClosureReasonDescription = null;
    let mom: moment.Moment = DateTimeHelper.roundMinute();
    this.dtTicketInterventionReport = new TicketInterventionReport(
      mom.format('YYYY-MM-DDTHH:mm:00'),
      mom.add(30, "m").format('YYYY-MM-DDTHH:mm:00')
    )
    this.storeSetDocumentParameter({ key: '' })
  }

  loaded = 0;
  handleReceiveNewMessage(message) {
    let actions = this.coActions.map(x => x)
    if (message.message) {
      const convertedCreated = moment(message.message.createdAt).format();
      const currentMessage = this.dtMessages.find(x => x.createdAt === convertedCreated);
      if (currentMessage) {
        let indexMsg = this.dtMessages.findIndex(x => x.createdAt === convertedCreated)
        this.dtMessages.splice(indexMsg, 1)
        actions.splice(-1, 0, message)
        this.coActions = actions
        this.storeMarkAsRead(this.$route.params.cid);
        return;
      }
    }
    /**Check for temporary message */
    const tempMessageIndex: number = this.dtMessages.findIndex(x => x.loader_id === message.loader_id && x.id === undefined);
    if (tempMessageIndex > -1) {
      setTimeout(() => {
        this.dtMessages[tempMessageIndex].uploaded = true;
        this.dtMessages[tempMessageIndex].attachment.media.downloadLink = message.attachment.media.link;

        this.dtMessages.splice(tempMessageIndex, 1)
        actions.splice(-1, 0, message)
        this.coActions = actions
      }, 200);
      this.storeMarkAsRead(this.$route.params.cid);
      return;
    } else {
      const index = this.dtMessages.filter(x => x.id === message.id).length === 0;
      const notExistedYet = actions.filter(x => x.id === message.id).length === 0;
      if (index && notExistedYet) {
        this.dtMessages.push(message);
        this.storeMarkAsRead(this.$route.params.cid);
      } else if (message.action_type === 'message_edit') {
        setTimeout(() => {
          actions.push(message)
          let msgIndex = actions.findIndex((x:any) => {
            return x.message!==null && x.message.id === message.message.id
          })
          let msg = { ...message }
          msg.action_type = 'message'
          actions.splice(msgIndex, 1, msg)
          this.coActions = actions
          this.dtMessages = []
        }, 200);
      } else if (message.action_type === 'message_delete') {
        let msgIndex = actions.findIndex(x => x.id === message.id)
        actions.splice(msgIndex, 1)
        this.coActions = actions
      } else {
        let msgIndex = actions.findIndex(x => x.id === message.id)
        if (msgIndex > -1) {
          let msg = { ...message }
          actions.splice(msgIndex, 1, msg)
          this.coActions = actions
        }
      }
      if (message.action_type === 'attachment_delete') {
        setTimeout(() => {
           actions = _.filter(actions, function(x) { return x.id !== message.id });
           this.coActions = actions
           this.dtMessages = _.filter(this.dtMessages , function(x) { return x.id !== message.id });
        }, 200);
       }
    }
  }

  handleSendMessage(message: string) {

    const messageId: number = new Date().getTime() + 2;
    const createdAt: string = new Date().toISOString();
    const createdMoment: string = moment(createdAt).format()

    const tempMessage = {
      id: messageId,
      action_type: "message",
      actor: {
        entity: {
          id: this.userInfo.id,
          firstname: this.userInfo.firstname,
          lastname: this.userInfo.lastname
        },
        fk_actor_entity: this.userInfo.id,
        id: messageId + 1,
      },
      message: {
        id: new Date().getTime(),
        fk_message_action: new Date().getTime() + 1,
        message,
        createdAt: createdMoment
      },
      ownerId: this.userInfo.id,
      ticket_id: Number(this.$route.params.id),
      fk_action_channel: Number(this.$route.params.cid),
      createdAt: createdMoment,
      temporaryCreatedAt: createdAt,
      error: null,
      is_loading: false
    }

    this.dtMessages.push(tempMessage)

    this.storeSendMessage({
      ticketId: this.$route.params.id,
      channelId: this.$route.params.cid,
      message,
      createdAt: createdAt
    })
      .then(res => {
        // Update action bar if ticket is close
        if (this.currentTicket.state === StateTypes.Close) {
          setTimeout(() => {
            this.storeGetTicket({ ticketId: parseInt(this.$route.params.id), isTicketModule: true })
              .then(ticket => console.log(ticket, 'ticket'))
              .catch(error => console.log(error))
          }, 300);
        }
      })
      .catch(error => {
        tempMessage.error = this.$t(this.lblSetting.ticketFailedMessage)
      })
  }

  handleResendMessage(event) {
    const { message } = event;
    this.storeSendMessage({
      ticketId: this.$route.params.id,
      channelId: this.$route.params.cid,
      message: message.message.message,
      createdAt: message.temporaryCreatedAt
    })
      .then(res => {
        message.is_loading = false
        message.error = null
      })
      .catch(error => {
        message.is_loading = false
      })
  }


  handleSendDocument(file) {
    this._handleSendfile(file)
  }

  private _handleSendfile(doc, index: number = 0) {

    let createdAt: string;
    if (this.dtMessages.length > 0 && this.coActions.length < 5) {
      const indexOf = this.dtMessages.length - 1
      createdAt = moment(this.dtMessages[indexOf].updatedAt).add("s", index + 10).format();
    } else {
      createdAt = moment().add("s", index + 30).format();
    }

    const transferFile: any = {
      loader_id: doc.loader_id || `${new Date().getTime()}-${this.dtMessages.length}`,
      fakeId: doc.fakeId,
      type: doc.customType || doc.type,
      file: doc.url || doc.file,
      name: doc.name,
      percentage: doc.percentage,
      action_type: doc.customType || doc.type,
      attachment: {
        media: {
          link: doc.url || doc.file,
          type: doc.type,
          ownType: doc.customType,
          name: doc.name,
          downloadLink: null
        }
      },
      actor: {
        fk_actor_entity: this.userInfo.id,
        entity: this.userInfo
      },
      createdAt: createdAt,
      uploaded: false,
      error: null,
      index: this.dtMessages.length,
      createdBy: this.userInfo.id,
      fkChannel: this.$route.params.cid
    }

    if(
      doc.hasOwnProperty('attributes') &&
      doc.hasOwnProperty('reference') &&
      doc.hasOwnProperty('fk_attachment_type') &&
      doc.hasOwnProperty('fk_attachment_type_level_2'))
    {
      transferFile.attributes = doc.attributes
      transferFile.reference = doc.reference
      transferFile.fk_attachment_type = doc.fk_attachment_type
      transferFile.fk_attachment_type_level_2 = doc.fk_attachment_type_level_2
    }

    this.dtMessages.unshift(transferFile)


    const tran: any = {
      ticketId: this.$route.params.id,
      channelId: this.$route.params.cid,
      data: transferFile
    }

    if (doc.creator) {
      tran.creator = doc.creator.id
      transferFile.creator = doc.creator
      transferFile.createdBy = doc.creator.id
      transferFile.actor = {
        entity: doc.creator,
        fk_actor_entity: doc.creator.id
      }
    }

    this.storeSendFile(tran).then(data=>{
      this.$store.commit('document/DOCUMENT_SET_DOCUMENT',{
        attachments:[],
        share:[],
        type:null,
        typeLvl2:null,
      })
    }).catch(err => {
        const indeOfItem = this.dtMessages.findIndex(x => x.loader_id === err.loader_id);
        if (indeOfItem > -1) {
          this.dtMessages[indeOfItem].error = err.error;
        }
      })
  }
  get buttonLoading(): boolean {
    return this.dtFileUploading === true || this.dtSendInterventionReportLoading === true;
  }
  get conversationAttachments() {
    const fromDb = this.coActions.filter(x => x.action_type === "attachment")
    const fromClientside = this.dtMessages.filter(x => x.uploaded)
    const result = [...fromDb, ...fromClientside];

    return _.orderBy(result, ['createdAt', 'asc'])
  }
  handleRecord(event) {
    clearTimeout(this._clearTimeout)
    this._clearTimeout = setTimeout(() => {

      if (this.dtRequestModal.type === TicketChatEditor.TICKET_EDITOR_ACTION_GENERATE_REPORT) {

        const startDate = new Date(this.dtTicketInterventionReport.start_date);
        const endDate = new Date(this.dtTicketInterventionReport.end_date);

        if (startDate > endDate) return;

        this.dtSendInterventionReportLoading = true;
        this.storeRecordInterventionReport({ ticketId: this.$route.params.id, data: this.dtTicketInterventionReport })
          .then(res => {
            this.dtSendInterventionReportLoading = false;
            this.dtRequestModal.type = null;
            this.dtRequestModal.visible = false;
            let mom: moment.Moment = DateTimeHelper.roundMinute();
            this.dtTicketInterventionReport = new TicketInterventionReport(
              mom.format('YYYY-MM-DDTHH:mm:00'),
              mom.add(30, "m").format('YYYY-MM-DDTHH:mm:00')
            )
          })
          .catch(res => {
            this.dtSendInterventionReportLoading = false;
          })

        return;
      }

      try {
        const payload = {
          ticketId: this.$route.params.id,
          channelId: this.$route.params.cid,
          actionName: this.dtRequestModal.actionName,
          data: null,
          textKey: null
        }
        switch (this.dtRequestModal.type) {
          case TicketChatEditor.TICKET_EDITOR_ACTION_CREATEAPPOINTMENT:
            this.storeRecordAppointment()
              .then(response => console.log(response))
              .catch(error => console.log(error))
            return;
          case TicketChatEditor.TICKET_EDITOR_ACTION_ASKAPPOINTMENT:
            this.storeAskAppointment({
              ticketId: parseInt(this.$route.params.id),
              startDate: this.dtDate.startDate
            })
              .then(response => {
                const date = moment()
                this.dtDate = {
                  startDate: date.format('YYYY-MM-DDTHH:mm:ss'),
                  endDate: date.add(30, 'm').format('YYYY-MM-DDTHH:mm:ss')
                }
                this.dtRequestModal.type = null;
                this.dtRequestModal.visible = false;
              })
              .catch(error => console.log(error))
            return;
          case TicketChatEditor.TICKET_EDITOR_ACTION_MANDATEASPEAKER:
            payload.data = this.dtMandateRequestPayload;
            payload.textKey = 'service_order'
            break;
          case TicketChatEditor.TICKET_EDITOR_ACTION_ATTACHDOCUMENT:
            eventBus.$emit('DOC_SAVE_FILES_ATTRIBUTES')
            this.dtFileUploading = true;
            // this.dtAttachments.forEach((doc, index) => this._handleSendfile(doc, index));
            // this.storeSendDocument({ ticketId: this.$route.params.id, channelId: this.$route.params.cid })

            function getRandomInt(min,max) {
              return Math.floor(Math.random() * (max - min + 1)) + min;
            }

            const docs = this.$store.state.document.document
            docs.attachments.forEach((doc, index) => {
              let docToSend = {
                reference:doc.reference,
                attributes:doc.attributes,
                fk_attachment_type:docs.type,
                fk_attachment_type_level_2:docs.typeLvl2,
                file:doc.file,
                name:doc.name,
                percentage: 0,
                fakeId: getRandomInt(1000000,9000000),
                loader_id: getRandomInt(1000000,9000000),
                type:doc.type
              }
              this._handleSendfile(docToSend, index)
            });
            return;
          case TicketChatEditor.TICKET_EDITOR_ACTION_CLOSE:
            if (this.dtClosureReason) {
              payload['reason'] = {
                action_type: 'close',
                fk_closure_reason: this.dtClosureReason.id,
                closure_description: this.dtClosureReasonDescription,
                //fk_ticket_reason:this.dtTicketReason.id,
              }
              if(this.dtTicketReason){
                payload['reason'].fk_ticket_reason = this.dtTicketReason.id
              }
            }
            break;
          case TicketChatEditor.TICKET_DELETE_MSG:
            this.dtConfirm.func(this.dtConfirm)
            return
          default:
            payload.data = this.dtQuoteRequestPayload;
            payload.textKey = 'quote_request_text'
            break;
        }
        this.storeTicketActionRequest(payload)
          .then((promises: Promise<any>[]) => {
            setTimeout(() => {
              this.storeGetTicket({ ticketId: parseInt(this.$route.params.id), isTicketModule: true })
                .then(ticket => console.log(ticket, 'ticket'))
                .catch(error => console.log(error))
            }, 3000);
          })
          .catch(error => console.log(error))
      } catch (error) {
        throw error;
      } finally {
        setTimeout(() => {
          this.dtRequestModal.type = null;
          this.dtRequestModal.visible = false;
          this.dtFileUploading = false;
          this.dtMandateRequestPayload = this.initMandate('service_order');
          this.dtQuoteRequestPayload = this.initMandate('quote_request_text');
        }, 100);
      }
    }, 300);
  }
  handleReopenTicket() {
    this.storeTicketActionRequest({ actionName: 'actionReopenTicket', ticketId: this.$route.params.id })
      .then(reponse => console.log(reponse))
      .catch(error => console.log(error))
  }

  handleDuplicateTicket() {
    this.$emit('add')
  }

  @Emit('update')
  handleUpdateTicket() { }

  handleJoinTicket() {
    clearTimeout(this._clearTimeout);
    this._clearTimeout = setTimeout(() => {
      this.dtRequestLoading = true;
      if (this.coCanJoinTicket) {
        this.storeRequestToJoin({
          ticketId: this.$route.params.id,
          channelId: this.$route.params.cid
        })
          .then(response => {
            this.dtRequestLoading = false;
            this.storeGetTicket({ ticketId: parseInt(this.$route.params.id), isTicketModule: true })
          })
          .catch(error => {
            this.dtRequestLoading = false;
            console.log(error)
          })
      }
    }, 300);
  }

  handleJoinChannel() {
    clearTimeout(this._clearTimeout)
    this._clearTimeout = setTimeout(() => {
      this.dtRequestLoading = true;
      this.storeRequestToJoinChannel({
        ticketId: this.$route.params.id,
        channelId: this.$route.params.cid
      }).then(res => {
        this.dtRequestLoading = false
        this.storeGetChannel({ ticketId: this.coCurrentTicketId, channelId: this.coCurrentChannelId })
      }).catch(err => {
        this.dtRequestLoading = false
      })
    }, 300);
  }
  handleSaveWithoutValidate(event: string) {

    clearTimeout(this._clearTimeout)
    this._clearTimeout = setTimeout(() => {
      const modal: any = this.$refs['modal'];
      if (modal.$refs.form.validate()) {
        this.dtWithoutValidateIsLoading = true;
        this.storeRecordAppointment('draft')
          .then(response => {
            this.dtWithoutValidateIsLoading = false;
            this.dtRequestModal.type = null;
            this.dtRequestModal.visible = false;
          })
          .catch(error => {
            this.dtWithoutValidateIsLoading = false;
          })
      }
    }, 300);

  }

  async handleRemoveParticipant(event) {
    await this.storeRemoveParticipant({ data: [event], ticketId: this.$route.params.id, channelId: this.$route.params.cid, })
      .catch(err => {
        this.dtError = err;
        this.dtErrorModalVisible = true
      })
  }
  handleRemoveError() {
    this.dtErrorModalVisible = false;
    this.dtError = null;
  }
  handleGoBack() {
    this.dtDetailErrorModalVisible = false;
    this.dtDetailError = null;
    this.$router.go(-1);
  }

  onAppointmentFieldUpdate() {
    this.dtUpdateAppointmentField = true
    setTimeout(() => {
      this.dtUpdateAppointmentField = false
    }, 1000)
  }
  destroyed() {
    this.storeClearCurrentChannel(null);
    this.dtMessages = [];
    this.dtMessage = null;
    this.storeResetCurrentChannel();
  }

}

export default TicketChatChildContainer;



// WEBPACK FOOTER //
// ./src/containers/ticket/ticket-child-chat/index.ts